<template>
  <div class="item">
    <QS-h4-title title="交接信息" />
    <el-form  ref="stockRef" :model="stock" :rules="rulesStock">
      <QS-column-box :labelWidth="160" :column="2">
        <el-form-item prop="actualTakeOverName" :label="'还车人姓名' + columnSeparator">
          <el-input v-model="stock.actualTakeOverName" clearable maxlength="20" placeholder="请输入提车人姓名">
          </el-input>
        </el-form-item>
        <el-form-item prop="actualTakeOverTel" :label="'还车人联系电话' + columnSeparator">
          <el-input v-model="stock.actualTakeOverTel" clearable v-number:phone
            placeholder="请输入提车人联系电话">
          </el-input>
        </el-form-item>
        <el-form-item prop="takeOverManager" :label="'交接车管' + columnSeparator">
          <el-select v-model="stock.takeOverManager" placeholder="请选择交接车管" clearable filterable>
            <el-option v-for="item in carTubeList" :label="item.userName" :value="item.id" :key="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="displayMile" :label="'表显里程' + columnSeparator">
          <el-input v-number:km v-model="stock.displayMile" placeholder="请输入表显里程" clearable>
            <template slot="append">公里</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="remainingReserves" class="remainingReserves" :label="'剩余电量/油量' + columnSeparator">
          <el-input v-model="stock.remainingReserves" clearable maxlength="20">
          </el-input>
        </el-form-item>
        <el-form-item prop="takeOverTime" :label="'交接完成时间' + columnSeparator">
          <el-date-picker v-model="stock.takeOverTime" format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="请选择交接完成时间" clearable
            :picker-options="takeOverTimeOption"
          />
          <p class="form-item-tips-red">交接完成时间将影响后续退车核算相关费用，请务必准确填写</p>
        </el-form-item>
        <el-form-item prop="hasKey" :label="'车钥匙' + columnSeparator">
          <el-radio-group v-model="stock.hasKey">
            <el-radio :label="1">有钥匙</el-radio>
            <el-radio :label="0">无钥匙</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="hasCarLicense" :label="'行驶证' + columnSeparator">
          <el-radio-group v-model="stock.hasCarLicense">
            <el-radio :label="1">有行驶证</el-radio>
            <el-radio :label="0">无行驶证</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item  :label="'备注' + columnSeparator" class="textare205">
          <el-input v-model="stock.remarks" type="textarea" placeholder="请输入备注" maxlength="500"
            show-word-limit clearable>
          </el-input>
        </el-form-item>
      </QS-column-box>
    </el-form>
  </div>
</template>
<script>
import { isIntiger } from '@/utils/validate'
import { getContactNumber } from '@/utils/extendFormVaildate'
import { getAllEmployeeList } from '@/api/carManage/index.js'
import { mapState } from 'vuex'


export default {
  inject: ['orderData'],
  props: {
    stockInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      carTubeList: [], // 车管
      stock: {
        displayMile: '',
        takeOverManager: '',
        takeOverTime: '',
        remarks: '',
        actualTakeOverName: '',
        actualTakeOverTel: '',
        remainingReserves: '',
        hasKey: 1,
        hasCarLicense: 1,
      },
      // 出入库校验
      rulesStock: {
        displayMile: [
          {
            validator: isIntiger,
            trigger: 'blur',
          },
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
        takeOverManager: [
          {
            required: true,
            message: '不能为空',
            trigger: ['blur', 'change'],
          },
        ],
        takeOverTime: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
        remarks: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
        actualTakeOverName: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
        actualTakeOverTel: [
          {
            required: true,
            trigger: 'blur',
            validator: getContactNumber,
          },
          {
            min: 11,
            max: 11,
            message: '格式不正确',
            trigger: 'blur',
          },
        ],
        remainingReserves: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
        hasKey: [
          {
            required: true,
            message: '请选择',
            trigger: 'change',
          },
        ],
        hasCarLicense: [
          {
            required: true,
            message: '请选择',
            trigger: 'change',
          },
        ],
      },
    }
  },
  watch: {
    stockInfo: {
      handler(val) {
        val && Object.keys(val).forEach((key) => {
          this.stock[key] = val[key]
        })
      },
      deep: true,
      immediate: true,
    },
    userInfo: {
      handler(val) {
        this.stock.takeOverManager = val.id
      },
    },
  },
  mounted() {
    this.getCarTubeList() // 获取车管
    // 进入入库验车跳转到顶部
    document.getElementsByClassName('personal-add')[0]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
  },
  methods: {
    //  获取车管
    async getCarTubeList() {
      const { code, data } = await getAllEmployeeList()
      if (code === 1) {
        this.carTubeList = data
      } else {
        this.$message.error('获取车管失败')
      }
    },
    // eslint-disable-next-line vue/no-unused-properties
    validateParams() {
      return new Promise((resolve, reject) => {
        this.$refs.stockRef.validate((valid) => {
          if (!valid) {
            this.$message.error('请填写必填项')
            reject()
          }
          resolve()
        })
      })
    },
  },
  computed: {
    takeOverTimeOption() {
      /**
       * 出库-1：租赁设置中的签约时间 <= 车辆交接时间 <= 当前时间
       * 入库-2：订单出库时间 <= 车辆交接时间 <= 当前时间
       * */
      const { outStockTime } = this.stockInfo
      return {
        disabledDate: (time) => {
          return time.getTime() <= new Date(outStockTime).getTime() - 8.64e7 || time.getTime() > Date.now()
        },
      }
    },
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
}
</script>
<style scoped lang="scss">
.car-details {
  .item{
    ::v-deep .el-input--small {
      width: 205px;
    }
  }
}
.form-item-tips{
  font-size: 12px;
  color: #666;
  line-height: 20px;
}
.form-item-tips-red {
  font-size: 12px;
  color: red;
  line-height: 20px;
}
::v-deep .remainingReserves .el-form-item__error {
  top: 32px;
}
</style>
